import type React from 'react';

import classNames from 'classnames';

import type { InputProps } from './Input.types';

export const Input: React.FC<InputProps> = ({
  id,
  type,
  name,
  value,
  placeholder,
  label,
  required = false,
  disabled = false,
  onChange,
  className = '',
  helperText,
}) => (
  <div className="flex flex-col gap-1">
    <label htmlFor={id} className="block text-sm text-gray-900 font-medium leading-5">
      {label}
      {required && '*'}
    </label>
    <input
      id={id}
      type={type}
      name={name}
      className={classNames(
        'w-full border border-gray-200 rounded-md shadow-sm px-3 py-2 text-gray-900 font-normal text-sm leading-5 focus:outline-none focus:ring-2 focus:text-sm',
        disabled ? 'bg-gray-100' : 'bg-white',
        className,
      )}
      defaultValue={value}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      onChange={onChange}
    />
    {helperText && <p className="text-sm text-gray-600">{helperText}</p>}
  </div>
);
